'use client';

import { Suspense } from 'react';
import ClientOnlyJobContent from './ClientOnlyJobContent';

// Loading skeleton component
function JobDetailsSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto p-6">
        <div className="animate-pulse space-y-6">
          {/* Header skeleton */}
          <div className="space-y-3">
            <div className="h-4 bg-gray-200 rounded w-1/4"></div>
            <div className="h-8 bg-gray-200 rounded w-3/4"></div>
          </div>
          
          {/* Badges skeleton */}
          <div className="flex gap-2">
            <div className="h-6 bg-gray-200 rounded w-24"></div>
            <div className="h-6 bg-gray-200 rounded w-32"></div>
            <div className="h-6 bg-gray-200 rounded w-40"></div>
          </div>
          
          {/* Content skeleton */}
          <div className="space-y-4">
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            <div className="h-4 bg-gray-200 rounded w-4/6"></div>
            <div className="h-4 bg-gray-200 rounded w-3/6"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Define the type for our route parameters
interface PageProps {
  params: Promise<{
    orgId: string;
    jobId: string;
  }>;
}

/**
 * The main JobDetailsPage component - now pure client-side
 * All data fetching will be handled by the ClientOnlyJobContent component
 */
export default async function JobDetailsPage({ params }: PageProps) {
  const { orgId, jobId } = await params;
  return (
    <Suspense fallback={<JobDetailsSkeleton />}>
      <ClientOnlyJobContent 
        orgId={orgId}
        jobId={jobId}
      />
    </Suspense>
  );
}